import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import api from '../../services/api';
import { showSuccess, showError } from '../../services/alert';

const CertificadoDigital = () => {
  const [arquivo, setArquivo] = useState(null);
  const [senha, setSenha] = useState('');
  const [certificado, setCertificado] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleFileChange = (e) => {
    setArquivo(e.target.files[0]);
  };

  const carregarCertificado = async () => {
    try {
      const response = await api.get('/certificado/dados');
      setCertificado(response.data);
    } catch (error) {
      // Se não houver certificado, apenas ignora
      setCertificado(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarCertificado();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!arquivo) {
      showError('Selecione o arquivo .pfx do certificado digital.');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('arquivo', arquivo);
      formData.append('senha', senha);

      await api.post('/certificado/salvar', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      showSuccess('Certificado digital salvo com sucesso!');
      setArquivo(null);
      setSenha('');
      await carregarCertificado();
    } catch (error) {
      console.error(error);
      showError('Erro ao salvar certificado digital.');
    }
  };

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="flex-grow-1">
        <Header title="Certificado Digital" />
        <div className="container py-4">
          <div className="card shadow p-4">

            <h5 className="mb-3">Certificado Digital</h5>

            {loading ? (
              <p>Carregando certificado...</p>
            ) : certificado ? (
              <div className="alert alert-success">
                <strong>Certificado cadastrado</strong>
                <br />
                Arquivo: <b>{certificado.nomeArquivo}</b>
                <br />
                Data do Cadastro:{' '}
                {new Date(certificado.dataUpload).toLocaleString()}
              </div>
            ) : (
              <div className="alert alert-warning">
                Nenhum certificado digital cadastrado.
              </div>
            )}

            <hr />

            <h6 className="mb-3">Cadastrar / Atualizar Certificado</h6>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Arquivo (.pfx)</label>
                <input
                  type="file"
                  className="form-control"
                  accept=".pfx"
                  onChange={handleFileChange}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Senha</label>
                <input
                  type="password"
                  className="form-control"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                />
              </div>

              <button type="submit" className="btn btn-success">
                Salvar Certificado
              </button>
            </form>

          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificadoDigital;
